import { ListItem } from "@domain/common/list-view/list-item";

/**
 * Classe représentant une liste opeCarte
 */
export class ListOpeCarte implements ListItem {
    idOpeCarte: string;
    numero: string;
    contrat: string;
    dateVente: Date;
    enseigne: string;
    localite: string;
    mccLibelle: string;
    deviseAchat: string;
    montantAchat: number;
    deviseReglement: string;
    montantReglement: number;
    numCarte: string;
    etatOperation: EtatOperation;
    montantRestant: number;
    ndfAssocies: string
    debit: TypeDebit;
    data: any;

    getKey(): string {
        return this.idOpeCarte;
    }
}

/**
 * Enum des états opération
 */
export enum EtatOperation {
    NON_JUSTIFIE = "0",
    DEPENSES_PERSONNELLES = "1",
    ARCHIVES = "2",
    EN_ATTENTE = "3",
    PARTIELLEMENT_JUSTIFIE = "4",
    JUSTIFIE = "5"
}

/**
 * Enum des types de débit
 */
export enum TypeDebit {
    UNDEFINED,
    SOCIETE,
    COLLAB
}